import React from "react";
import { useIntl } from "react-intl";
import styles from "./DropdownResults.module.scss";
import { CompanyProposition } from "../hooks/useFetchAutocompleteCompanies";

interface DropdownResultsProps {
  companies: CompanyProposition[];
  isLoading: boolean;
  isError: boolean;
  onSelectCompany: (company: CompanyProposition) => void;
}
export const renderAddress = ({ address }: CompanyProposition) => {
  return `${address.street} ${address.zipCode} ${address.city}, ${address.country}`;
};
const DropdownResults: React.FC<DropdownResultsProps> = ({
  companies,
  isLoading,
  isError,
  onSelectCompany,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.dropdown}>
      {isLoading && (
        <div className={styles.loading}>
          {intl.formatMessage({ id: "loading" })}
        </div>
      )}
      {!isLoading && companies.length > 0 && (
        <ul className={styles.resultList}>
          {companies.slice(0, 5).map((company: CompanyProposition, index) => (
            <li
              key={index}
              className={styles.resultItem}
              onClick={() => onSelectCompany(company)}
            >
              <div className={styles.companyName}>{company.businessName}</div>
              <div className={styles.siret}>{company.siret}</div>
              <div className={styles.address}>{renderAddress(company)}</div>
              {index < companies.length - 1 && (
                <div className={styles.separator}></div>
              )}
            </li>
          ))}
        </ul>
      )}
      {(!isLoading || isError) && companies.length === 0 && (
        <div className={styles.noResults}>
          {intl.formatMessage({ id: "noResults" })}
        </div>
      )}
    </div>
  );
};

export default DropdownResults;
